import { render, staticRenderFns } from "./FacturasYNotasDeCredito.vue?vue&type=template&id=322d1fdd"
import script from "./FacturasYNotasDeCredito.vue?vue&type=script&lang=js"
export * from "./FacturasYNotasDeCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports